import React from 'react';
import { ReactModel } from '../../react-model/react-model';
import { useOnModelChange } from '../hooks/use-on-model-change';

export interface HSpanProps<T> extends React.HTMLAttributes<HTMLSpanElement> {
	model: ReactModel<T>;
	field?: keyof NonNullable<T>;
	/** Set the component properties when then model changes */
	onModelChange?: (state: T) => void | React.HTMLAttributes<HTMLSpanElement>;
	/** The word "ref" is reserved. We have to use ref2 */
	ref2?: { current: HTMLSpanElement | null };
	//onChange?:(e:React.ChangeEvent<HTMLInputElement>)=>void,
}

/**
 * field value cannot be a react element.
 * To display an react element, use onModelChange() and return {children:...}
 */
export function HSpan<T>({ model, field, ref2, onModelChange, ...props }: HSpanProps<T>) {
	//do not extract "children" from the parameter. In this way, the "children" property can be effect in useOnModelChange()

	let text: any;
	if (field) {
		text = (model.useModel().state as any) [field];
	}

	useOnModelChange(model, onModelChange, props);

	return (
		<span
			{...props}
			ref={ref2}
			//data-model-id={model.model_id.toString()}
		>
			{text === null || text === undefined ? '' : text.toString()}
			{props.children}
		</span>
	);
}
